export enum ConsentType {
  Privacy = 1,
}